"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSupplierTd = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var Option = antd_1.Select.Option;
var SelectSupplierTd = function (props) {
    var _a = props.cell, colSpan = _a.colSpan, path = _a.path, rowSpan = _a.rowSpan, value = _a.value;
    var onChangeV = props.onValueUpdate;
    var _b = (0, react_1.useState)(''), supplierName = _b[0], setSupplierName = _b[1];
    var activeStatus = true;
    var supplierSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.suppliersRef
        .where('nameIndex', 'array-contains', supplierName.toLowerCase().trim())
        .where('active', '==', activeStatus)
        .limit(9)
        .limit(9))[0];
    var currentSupplierSn = (0, firestore_1.useDocument)(value ? collectionsRef_1.suppliersRef.doc(value) : undefined)[0];
    var isValueUndefined = (value !== null && value !== void 0 ? value : '').trim() === '' || value === null || value === undefined;
    var displayError = props.required && isValueUndefined && props.triedSubmitting;
    var currentSupplierData = currentSupplierSn === null || currentSupplierSn === void 0 ? void 0 : currentSupplierSn.data();
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: props.style, className: index_modules_css_1.default.gridTd, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ className: index_modules_css_1.default.selectCell, validateStatus: displayError ? 'error' : undefined }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Select, __assign({ style: { width: '100%', height: '100%', borderColor: displayError ? '#FF0000' : 'none' }, onChange: function (supplierId) {
                    var _a, _b;
                    var supplier = supplierSnapshot === null || supplierSnapshot === void 0 ? void 0 : supplierSnapshot.docs.find(function (x) { return x.id === supplierId; });
                    if (onChangeV) {
                        onChangeV(path, __assign(__assign({}, ((_a = supplier === null || supplier === void 0 ? void 0 : supplier.data()) !== null && _a !== void 0 ? _a : {})), { id: (_b = supplier === null || supplier === void 0 ? void 0 : supplier.id) !== null && _b !== void 0 ? _b : '' }));
                    }
                }, defaultValue: value, onSearch: function (e) { return setSupplierName(e); }, showSearch: true, optionFilterProp: "children" }, { children: [currentSupplierData ? (0, jsx_runtime_1.jsx)(Option, __assign({ value: currentSupplierSn.id }, { children: currentSupplierData.companyName })) : null, supplierSnapshot === null || supplierSnapshot === void 0 ? void 0 : supplierSnapshot.docs.map(function (supplier, key) {
                        return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: supplier.id }, { children: supplier.data().companyName }), key));
                    })] })) })) })));
};
exports.SelectSupplierTd = SelectSupplierTd;
